module.exports = {"newsletter":{"title":"Dapatkan rangking JS paling baru di inbox setiap minggu","text":"Daftar untuk newsletter {link} dan anda akan menerima statistik eksklusif tentang proyek JavaScript paling populer setiap minggunya.","button":"Daftar","placeholder":"Email Anda"},"view_project":{"twitter":{"text":"Tahun {year}, {name} menambahkan {delta} bintang, membuatnya berada di posisi #{ranking} paling populer pada kategori {category} di GitHub","action":"Tweet"},"months":"J F M A M J J A S O N D","created":"Created","homepage":"Homepage"}}


//////////////////
// WEBPACK FOOTER
// ./i18n/common/id.yaml
// module id = 452
// module chunks = 230186691558513